<div class="user-modal">
    <div class="user-modal__header">
        <h3>{{ title }}</h3>
        <button type="button" class="user-modal__close" (click)="activeModal.dismiss()" aria-label="Close">&times;</button>
    </div>

    <form class="user-modal__body" (ngSubmit)="save()">
        <label class="field">
            <span>Username</span>
            <input ngbAutofocus type="text" name="username" [(ngModel)]="username" autocomplete="off"
                [class.invalid]="usernameInvalid" [class.shake]="shaking && usernameInvalid" />
        </label>

        <div class="field-row">
            <label class="field">
                <span>Password</span>
                <input type="password" name="password" [(ngModel)]="password" autocomplete="new-password"
                    placeholder="{{ id ? 'Leave blank to keep' : '' }}"
                    [class.invalid]="passwordInvalid" [class.shake]="shaking && passwordInvalid" />
            </label>
            <label class="field">
                <span>Confirm password</span>
                <input type="password" name="confirmPassword" [(ngModel)]="confirmPassword" autocomplete="new-password"
                    [class.invalid]="passwordInvalid" [class.shake]="shaking && passwordInvalid" />
            </label>
        </div>

        <label class="field">
            <span>Name</span>
            <input type="text" name="name" [(ngModel)]="name" autocomplete="off" />
        </label>

        <div class="field-row">
            <label class="field">
                <span>Mobile</span>
                <input type="text" name="mobile" [(ngModel)]="mobile" autocomplete="off" />
            </label>
            <label class="field">
                <span>Email</span>
                <input type="email" name="email" [(ngModel)]="email" autocomplete="off"
                    [class.invalid]="emailInvalid" [class.shake]="shaking && emailInvalid" />
            </label>
        </div>

        <div class="field">
            <span>Categories</span>
            <ng-select
                class="tool-select"
                name="categoryIds"
                [items]="categories"
                bindLabel="categoryName"
                bindValue="id"
                [multiple]="true"
                [closeOnSelect]="false"
                placeholder="Select categories"
                [(ngModel)]="categoryIds">
            </ng-select>
        </div>

        <div class="checkbox-group">
            <label class="checkbox-row">
                <input type="checkbox" name="active" [(ngModel)]="active" />
                <span>Active</span>
            </label>
            <label class="checkbox-row">
                <input type="checkbox" name="isAdmin" [(ngModel)]="isAdmin" />
                <span>Admin</span>
            </label>
            <!-- Admins reach the dashboard anyway, so the box is redundant (and
                 disabled) while Admin is ticked. -->
            <label class="checkbox-row">
                <input type="checkbox" name="canAccessOrders" [(ngModel)]="canAccessOrders"
                    [disabled]="isAdmin" />
                <span class="stacked-label">
                    <span>Orders access</span>
                    <span class="hint">{{ isAdmin ? '(included with Admin)' : '(overview &amp; orders, not messages)' }}</span>
                </span>
            </label>
        </div>

        @if (error) {
            <p class="error">{{ error }}</p>
        }

        <button type="submit" class="user-modal__submit">Save</button>
    </form>
</div>
